import { Row, SortingRule } from 'react-table'

import { MIN_SEARCH_SYMBOLS } from './consts'
import type { TableHeader } from 'components/Table/types'

interface HeaderSort extends TableHeader {
  disableSortBy?: boolean
}

export const sortByDate = <D extends object>(
  rowA: Row<D>,
  rowB: Row<D>,
  columnId: string
): number => (rowA?.values[columnId] < rowB?.values[columnId] ? 1 : -1)

export const isCharsThresholdMet = (searchValue: string | undefined) =>
  !!searchValue && searchValue.length >= MIN_SEARCH_SYMBOLS

export const sortByInsensitiveString = <D extends object>(
  rowA: Row<D>,
  rowB: Row<D>,
  columnId: string,
  desc: boolean = true
): number => {
  const valueA = `${rowA.values[columnId]}`.toLowerCase()
  const valueB = `${rowB.values[columnId]}`.toLowerCase()

  if (desc) {
    return valueA.localeCompare(valueB) > 0 ? 1 : -1
  }
  return valueB.localeCompare(valueA) > 0 ? -1 : 1
}

export const getSortOptions = (
  headers: Record<string, HeaderSort>,
  reverse?: boolean
) =>
  Object.values(headers)
    .filter((header) => !header.disableSortBy)
    .map((header) => ({
      id: header.id,
      desc: reverse ? !header.desc : header.desc,
    }))

export const getSortLabel = (
  headers: Record<string, TableHeader>,
  sortBy: SortingRule<any>
) => {
  const header = Object.values(headers).find(
    (header) => header.id === sortBy.id
  )

  return header?.label || ''
}
